import type { AddEditCollaborator, Collaborator } from "@/types";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export const getCollaborator = async (
  collaboratorId: string,
): Promise<ServiceResponse<Collaborator>> => {
  const response = await privateAPI.get<ServiceResponse<Collaborator>>(
    `/collaborators/${collaboratorId}`,
  );
  return response.data;
};

export const getCollaborators = async (
  search?: string,
  type?: string,
): Promise<ServiceResponse<Collaborator[]>> => {
  const queryParams = new URLSearchParams();

  if (search) {
    queryParams.append("filter[name]", search);
  }
  if (type) {
    queryParams.append("filter[type]", type);
  }

  const query = queryParams.toString();
  const response = await privateAPI.get<ServiceResponse<Collaborator[]>>(
    `/collaborators${query ? `?${query}` : ""}`,
  );
  return response.data;
};

export const addCollaborator = async (
  collaborator: AddEditCollaborator,
): Promise<Collaborator> => {
  const response = await privateAPI.post<ServiceResponse<Collaborator>>(
    `/collaborators`,
    {
      ...collaborator,
    },
  );

  return response.data.data;
};

export const updateCollaborator = async ({
  collaboratorId,
  collaborator,
}: {
  collaboratorId: Collaborator["id"];
  collaborator: AddEditCollaborator;
}): Promise<Collaborator> => {
  const response = await privateAPI.put<ServiceResponse<Collaborator>>(
    `/collaborators/${collaboratorId}`,
    {
      ...collaborator,
    },
  );
  return response.data.data;
};
